import React, { Component } from 'react';
import InputList from '../../../shared/components/presentation/input-list/InputList';
import { Grid, GridItem } from '../../../shared/components/presentation/grid/Grid';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as webAppointmentActions from '../../actions/webAppointmentActions';
import { nextPage } from '../../functions/nextPage';
import * as defaultState from '../../constants/DefaultState';

export class AppointmentDayTimePage extends Component {

  isValid() {
    return true;
  }

  render() {
    const title = "What day and time work best for " + (this.props.forMe ? "you" : "them") + "?";

    let inputlist = [
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        inputs: [
          {
            type: 'checkbox-list',
            id: 'preferred-days',
            groupName: 'preferred-days',
            legend: 'Preferred day',
            onChange: (ev) => {
              // The checked checkboxes are stored as bits in a single integer:
              // Mon-1, Tue-2, Wed-4, Thur-8, Fri-16.
              // When one of the checkboxes is updated, flip (do an XOR (^) on)
              // the corresponding bit.  When all the bits are 0, the whole
              // number is 0, which indicates, "first available.  Checking
              // first available will set the number to 0, which will uncheck
              // the individual day checkboxes.
              let newDays = ev.target.value === "0" ? 0 : (this.props.appointment.day ^ JSON.parse(ev.target.value));
              this.props.webAppointmentSetAppointmentDay(newDays);
            },
            checkboxProps: [
              {
                label: "Monday",
                id: "prefer-monday",
                value: "1",
                checked: !!(this.props.appointment.day & 1),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "Tuesday",
                id: "prefer-tuesday",
                value: "2",
                checked: !!(this.props.appointment.day & 2),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "Wednesday",
                id: "prefer-wednesday",
                value: "4",
                checked: !!(this.props.appointment.day & 4),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "Thursday",
                id: "prefer-tursday",
                value: "8",
                checked: !!(this.props.appointment.day & 8),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "Friday",
                id: "prefer-friday",
                value: "16",
                checked: !!(this.props.appointment.day & 16),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "First available",
                id: "prefer-no-pref",
                value: "0",
                checked: this.props.appointment.day === 0,
                checkboxWrapperClassName: "checkbox-wrapper"
              }
            ]
          },
          {
            type: 'checkbox-list',
            id: 'preferred-times',
            groupName: 'preferred-times',
            legend: 'Preferred time of day',
            onChange: (ev) => {
              // See the comment above for the preferred days.  This works
              // the same but with only two bits.
              let newTimes = ev.target.value === "0" ? 0 : (this.props.appointment.time ^ JSON.parse(ev.target.value));
              this.props.webAppointmentSetAppointmentTime(newTimes);
            },
            checkboxProps: [
              {
                label: "AM",
                id: "prefer-am",
                value: "1",
                checked: !!(this.props.appointment.time & 1),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "PM",
                id: "prefer-PM",
                value: "2",
                checked: !!(this.props.appointment.time & 2),
                checkboxWrapperClassName: "checkbox-wrapper"
              },
              {
                label: "First available",
                id: "prefer-time-no-pref",
                value: "0",
                checked: this.props.appointment.time === 0,
                checkboxWrapperClassName: "checkbox-wrapper"
              }
            ]
          },
        ]
      },
      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          [
            {
              type: 'button',
              id: "back",
              className: "btn--secondary",
              value: 'Back',
              onClick: () => {
                this.props.history.goBack();
              }
            },
            {
              type: 'button',
              id: "next",
              className: "btn--primary",
              value: "Next",
              disabled: !this.isValid(),
              onClick: () => {
                this.props.history.push(nextPage());
              }
            }
          ]
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className='web-appt__header'>
              <h1>{title}</h1>
              <hr />
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
}

AppointmentDayTimePage.propTypes = {
  appointment: defaultState.appointmentProptype,
  forMe: PropTypes.bool.isRequired,
  webAppointmentSetAppointmentDay: PropTypes.func.isRequired,
  webAppointmentSetAppointmentTime: PropTypes.func.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    appointment: state.webAppointmentForm.appointment,
    forMe: state.webAppointmentForm.forMe
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentSetAppointmentDay: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentDay(value)),
    webAppointmentSetAppointmentTime: (value) => dispatch(webAppointmentActions.webAppointmentSetAppointmentTime(value)),
  };
};

// connects component to redux, and passes along the router
export default connect(mapStateToProps, mapDispatchToProps)(AppointmentDayTimePage);
